import styled, { css } from 'styled-components';
import { APPS_MAP } from '../../constants/config';

const getColor = (props) => {
  if (!props.appContainer) {
    return 'transparent';
  }
  if (props.appContainer === APPS_MAP.SEGMENTATION) {
    return `${props.theme.colors.violet}`;
  }

  if (props.appContainer === APPS_MAP.COMPARE) {
    return `${props.theme.colors.green}`;
  }

  return `${props.theme.colors.secondary}`;
};

const getHoverSelectedCssLine = (props) => {
  return css`
    &:before {
      content: '';
      position: absolute;
      left: 0px;
      width: 100%;
      top: 0;
      z-index: 2;
      background: ${props.appContainer
        ? props.theme.colors.secondary
        : 'transparent'};
      height: 8px;
    }
  `;
};

const selectedState = (props) => {
  if (props.selected) {
    return css`
      box-shadow: none;
      background-color: white;
      border-bottom: 0;
      position:relative;
      ${(props) => getHoverSelectedCssLine(props)};

      &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0px
        height: 1px;
        z-index: 1;
        width: 100%;
        background-color: ${(props) => props.theme.colors.light};
      }
    `;
  }
};

const StyledTabs = styled.nav`
  width: 100%;
  max-width: 100%;
  position: relative;
  display: flex;
  align-items: start;
  justify-content: start;
`;

const StyledTabItemWrapper = styled.div`
  position: relative;

  padding: ${(props) =>
    `${props.theme.spacing.medium} ${props.theme.spacing.small} ${props.theme.spacing.small} ${props.theme.spacing.medium}`};
  border-right: 1px solid ${(props) => props.theme.colors.light_darker_1};
  display: flex;
  justify-content: space-between;
`;

const getPointer = ({ isDragging, draggable }) => {
  if (!draggable) {
    return 'pointer';
  }

  if (!isDragging) {
    return 'grab';
  }

  return 'grabbing';
};

const StyledTabItem = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
  min-width: 0;
  text-align: center;
  cursor: pointer;
  user-select: none;
  ${(props) => selectedState(props)};

  &:hover {
    ${(props) => getHoverSelectedCssLine(props)}
  }

  cursor: ${getPointer};
`;

const StyledContent = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.light_dark};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const StyledTabContent = styled.div`
  display: flex;
  max-width: 90%;
  align-items: center;
`;

const StyledTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledAppTab = styled.div`
  height: 100%;
  display: ${(props) => (props.selected ? 'block' : 'none')};
`;

const StyledTabIcon = styled.div`
  margin-right: 8px;
`;

export {
  StyledTabs,
  StyledTabItem,
  StyledTabItemWrapper,
  StyledTabContent,
  StyledContent,
  StyledTabsContainer,
  StyledTabIcon,
  StyledAppTab,
};
